import { createAction } from '@lingoda/core';

export const resetBaseBookingFilter = createAction('booking/RESET_BASE_BOOKING_FILTER');
